import { CircularProgress } from "@mui/material";
import React, { ComponentPropsWithoutRef, memo } from "react";

interface DropDownProps extends ComponentPropsWithoutRef<"select"> {
  error?: string;
  touched?: boolean;
  title?: string;
  isLoading?: boolean;
  options?: {
    name: string;
    id: number;
  }[];
}

const DropDown = ({
  error,
  touched,
  title,
  options,
  isLoading,
  ...props
}: DropDownProps) => {
  return (
    <div className="formElements__group w-full">
      {title ? <label className="formElements__label">{title}</label> : null}
      <div className="flex flex-row items-center">
        <select
          className={`w-100 formElements__dropdown 
				${touched && error ? "formElements__errorBorder" : ""}
        `}
          required
          {...props}
        >
          <option value="" disabled selected>
            Select your option
          </option>
          {options
            ? options.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.name}
                </option>
              ))
            : null}
        </select>
        {isLoading ? (
          <CircularProgress
            style={{ color: "blue", marginLeft: 10 }}
            size={20}
          ></CircularProgress>
        ) : null}
      </div>
      {touched && error ? (
        <div className="formElements__errorText">{error}</div>
      ) : null}
      <div className="invalid-feedback" />
    </div>
  );
};

export default memo(DropDown);
